import React, { FC } from "react";
import { useHistory } from "react-router-dom";

import { DEFAULT_PAGE } from "constants/routes.constants";

import styles from "../sidebar.module.css";
import logoImg from "assets/images/logo.svg";

type LogoProps = {
  isCollapsed: boolean;
};

const Logo: FC<LogoProps> = ({ isCollapsed }: LogoProps) => {
  const history = useHistory();

  const handleRedirectHome = () => {
    history.push(DEFAULT_PAGE.path);
  };

  return (
    <div className={styles.logo} onClick={handleRedirectHome}>
      <img src={logoImg} alt="" />
      {!isCollapsed && <span>ClicksUA</span>}
    </div>
  );
};

export default Logo;
